import { TRAFFIC, PLAYTIME } from '../../../constants/general';
import { getUsageColumnsSettings, getDefaultColumnsSettings } from '../TableColumnsSettings';

import { generateZoomInitialTables } from '../../../util/TableTools';

import {
   BINTU_ACCOUNTING,
   CONCURRENT_VIEWER,
   CONCURRENT_VIEWER_IDX,
   INGEST,
   MONTH2DATE,
   PI_USAGE,
   PLAYOUT,
} from '../ZoomConstants';
import { getIntegerWithDecimalSeparator } from '../../../util/NumberFormatter';

export const WIDGET_SETTINGS = {
   [PI_USAGE]: {
      title: {
         [TRAFFIC]: 'traffic',
         [PLAYTIME]: 'playtime',
      },
      exIndexName: BINTU_ACCOUNTING,
      initialTable: generateZoomInitialTables(['playout', 'ingest']),
      path: 'usage',
      pathParams: (usageSwitch) => `/${usageSwitch}`,
      dataAccessFn: (res) => res.data,
      categories: {
         labels: ['Playout', 'Ingest'],
         propNames: ['playout', 'ingest'],
      },
      columnNames: ['Usage'],
      columnsSettings: getUsageColumnsSettings,
   },
   [MONTH2DATE]: {
      title: {
         [TRAFFIC]: 'traffic',
         [PLAYTIME]: 'playtime',
      },
      exIndexName: BINTU_ACCOUNTING,
      initialTable: generateZoomInitialTables(['playout', 'ingest']),
      path: 'usage',
      pathParams: (usageSwitch) => `/${usageSwitch}`,
      dataAccessFn: (res) => res.data,
      categories: {
         labels: ['Playout', 'Ingest'],
         propNames: ['playout', 'ingest'],
      },
      columnNames: ['Usage'],
      columnsSettings: getUsageColumnsSettings,
   },
   [CONCURRENT_VIEWER]: {
      title: () => 'Breakdown of maximum concurrent viewers',
      exIndexName: CONCURRENT_VIEWER_IDX,
      initialTable: generateZoomInitialTables(['viewers']),
      path: 'viewers/concurrent',
      dataAccessFn: (res) => res.data,
      categories: {
         labels: ['Max. concurrent viewers'],
         propNames: ['viewers'],
      },
      dataFieldNames: ['max', 'avg'],
      columnNames: ['Maximum', 'Average'],
      columnsSettings: getDefaultColumnsSettings,
      formatters: [(cell) => getIntegerWithDecimalSeparator(cell), (cell) => getIntegerWithDecimalSeparator(cell)],
   },
   [PLAYOUT]: {
      title: {
         [TRAFFIC]: 'traffic',
         [PLAYTIME]: 'playtime',
      },
      exIndexName: BINTU_ACCOUNTING,
      initialTable: generateZoomInitialTables(['h5liveUsage', 'rtmpUsage', 'hlsUsage', 'h5liveTokenUsage']),
      path: 'usage/protocol',
      pathParams: (usageSwitch) => `/playout/${usageSwitch}`,
      dataAccessFn: (res) => res.data,
      categories: {
         labels: ['H5Live', 'RTMP', 'HLS', 'H5Live Token'],
         propNames: ['h5liveUsage', 'rtmpUsage', 'hlsUsage', 'h5liveTokenUsage'],
      },
      columnNames: ['Protocol usage'],
      columnsSettings: getUsageColumnsSettings,
   },
   [INGEST]: {
      title: {
         [TRAFFIC]: 'traffic',
         [PLAYTIME]: 'playtime',
      },
      exIndexName: BINTU_ACCOUNTING,
      initialTable: generateZoomInitialTables(['rtmpUsage', 'webrtcUsage']),
      path: 'usage/protocol',
      pathParams: (usageSwitch) => `/ingest/${usageSwitch}`,
      dataAccessFn: (res) => res.data,
      categories: {
         labels: ['RTMP', 'Webcaster'],
         propNames: ['rtmpUsage', 'webrtcUsage'],
      },
      columnNames: ['Protocol usage'],
      columnsSettings: getUsageColumnsSettings,
   },
};
